module.exports = __webpack_public_path__ + "img/coupon-bg.913eb4fb.png";